var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navbar Icon",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0783 10.8327C17.7686 10.8327 18.3283 11.3923 18.3283 12.0827V17.0827C18.3283 17.773 17.7686 18.3327 17.0783 18.3327H12.0783C11.3879 18.3327 10.8283 17.773 10.8283 17.0827V12.0827C10.8283 11.3923 11.3879 10.8327 12.0783 10.8327H17.0783ZM7.91406 10.8327C8.60442 10.8327 9.16406 11.3923 9.16406 12.0827V17.0827C9.16406 17.773 8.60442 18.3327 7.91406 18.3327H2.91406C2.22371 18.3327 1.66406 17.773 1.66406 17.0827V12.0827C1.66406 11.3923 2.22371 10.8327 2.91406 10.8327H7.91406ZM16.9116 12.2493H12.2449V16.916H16.9116V12.2493ZM7.7474 12.2493H3.08073V16.916H7.7474V12.2493ZM7.91406 1.66602C8.60442 1.66602 9.16406 2.22566 9.16406 2.91602V7.91602C9.16406 8.60637 8.60442 9.16602 7.91406 9.16602H2.91406C2.22371 9.16602 1.66406 8.60637 1.66406 7.91602V2.91602C1.66406 2.22566 2.22371 1.66602 2.91406 1.66602H7.91406ZM17.0783 1.66602C17.7686 1.66602 18.3283 2.22566 18.3283 2.91602V7.91602C18.3283 8.60637 17.7686 9.16602 17.0783 9.16602H12.0783C11.3879 9.16602 10.8283 8.60637 10.8283 7.91602V2.91602C10.8283 2.22566 11.3879 1.66602 12.0783 1.66602H17.0783ZM7.7474 3.08268H3.08073V7.74935H7.7474V3.08268ZM16.9116 3.08268H12.2449V7.74935H16.9116V3.08268Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.f360ad76f1ba2abe52ec562af54a0a24.svg";
export { ForwardRef as ReactComponent };